import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import FormInputText from "../../../../../components/form/FormInputText";
// INTERFACES
import { SetHostNameInterface } from "../../../../../../interfaces/AdapterCdoOpc.interface";

export default function ComponentSetHostName({
	data,
	setData,
}: {
	data: SetHostNameInterface;
	setData: (newValue: SetHostNameInterface) => void;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChangeValue = (newValue: string, variableName: string) => {
		const copy = structuredClone(data);
		if (variableName === "name") {
			copy.host_name = newValue;
		}
		setData(copy);
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			<FormInputText
				inputValue={data.host_name}
				inputLabelName={t("general.hostName")}
				inputOnChange={onChangeValue}
				inputVariableName='host_name'
				isRequired
				disabledInput={false}
				
			/>
		</div>
	);
}
